import App from './src/App';

import './src/css/main.scss';

// eslint-disable-next-line import/prefer-default-export
export const wrapRootElement = App;
